import { gql } from '@apollo/client'

export const UPDATE_PlANOGRAM_FOR_ZONE = gql`
  mutation UpdatePlanogramForZone($input: UpdatePlanogramForZoneInput!) {
    updatePlanogramForZone(input: $input) {
      success
      planogram {
        id
        name
        zone {
          id
          name
        }
        fixtureType {
          id
          name
        }
        numSegments
        segments {
          segmentNumber
          shelves {
            displayShelfNumber
            idealInventory {
              upc
              vFacings
            }
          }
        }
      }
    }
  }
`
